import actionTypes from '../actionTypes';

export function updateTournamentPlayers(id, players) {
  return {
    id,
    players,
    type: actionTypes.TOURNAMENT_PLAYER_UPDATE,
  };
}